/* מעדכן את כותרת המסמך ואת תיאור המטא בהתאם לעמוד המוצג.
   התיאור אופציונלי: עמוד שאינו מספק אותו משאיר את תיאור ברירת המחדל
   שב-index.html, ולכן אין צורך לשנות עמודים קיימים. */
import { useEffect } from 'react';

/** מעדכן את תוכן תגית ה-meta description, ומחזיר את הערך הקודם לשחזור. */
function setMetaDescription(content: string): string | null {
  const tag = document.querySelector('meta[name="description"]');

  if (!tag) {
    return null;
  }

  const previous = tag.getAttribute('content');

  tag.setAttribute('content', content);

  return previous;
}

export function useDocumentTitle(title: string, description?: string): void {
  useEffect(() => {
    document.title = title;
  }, [title]);

  useEffect(() => {
    if (description === undefined) {
      return;
    }

    /* התיאור המקורי מוחזר ביציאה מהעמוד, כדי שניווט לעמוד ללא תיאור
       ייעודי לא ישאיר את התיאור של העמוד הקודם. */
    const previous = setMetaDescription(description);

    return () => {
      if (previous !== null) {
        setMetaDescription(previous);
      }
    };
  }, [description]);
}
